import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import { 
  GET_TYPE_SETTINGS, 
  // GET_ADMIN_PROFILE,
  ADD_NEW_TYPE_SETTING,
  UPDATE_TYPE_SETTING,
  DELETE_TYPE_SETTING
 } from "./actionTypes";
import {
  getType_settingsSuccess,
  getType_settingsFail,
  addType_settingSuccess,
  addType_settingFail,
  updateType_settingSuccess,
  updateType_settingFail,
  deleteType_settingSuccess,
  deleteType_settingFail,
  // getType_settingsProfileSuccess,
  // getType_settingsProfileFail,
} from "./actions";

//Include Both Helper File with needed methods
import { 
  getType_Settings,
  // getType_settingsProfile,
  addNewType_Setting,
  updateType_Setting,
  deleteType_Setting
} from "../../helpers/backend_helper";
import { showPopup } from "../popup/actions";

function* fetchType_settings({payload : {vendor_type_id,is_active,offset,page_size}}) {
  try {
    const response = yield call(getType_Settings,{vendor_type_id,is_active,offset,page_size});
    yield put(getType_settingsSuccess(response));
  } catch (error) {
    yield put(getType_settingsFail(error));
      yield put(showPopup({title:error.response.data.message,error:true}));

  }
}

function* onUpdateType_settings ({payload: ceremony }) {
  try {
    let response = yield call(updateType_Setting, ceremony);
   if(response.file_src || ceremony.removeImage) ceremony.image = response.file_src

    yield put(updateType_settingSuccess(ceremony));
    yield put(showPopup({title:response.message,success:true}));

  } catch (error) {
    yield put(updateType_settingFail(error));
      yield put(showPopup({title:error.response.data.message,error:true}));

  }
}

function* onDeleteType_settings({ payload: ceremony }) {
  
  try {
   const response =  yield call(deleteType_Setting, ceremony);
    yield put(deleteType_settingSuccess(ceremony));
    yield put(showPopup({title:response.message,success:true}));

  } catch (error) {
    yield put(deleteType_settingFail(error));
      yield put(showPopup({title:error.response.data.message,error:true}));

  }
}

function* onAddNewType_settings({ payload: ceremony }) {
  try {
    const response =  yield call(addNewType_Setting, ceremony);
    yield put(addType_settingSuccess(response.data));
    yield put(showPopup({title:response.message,success:true}));

  } catch (error) {
    yield put(addType_settingFail(error));
      yield put(showPopup({title:error.response.data.message,error:true}));

  }
}


// function* fetchType_settingsProfile() {
//   try {
//     const response = yield call(getType_settingsProfile);
//     yield put(getType_settingsProfileSuccess(response));
//   } catch (error) {
//     yield put(getType_settingsProfileFail(error));
//   }
// }

function* ceremonysSaga() {
  yield takeEvery(GET_TYPE_SETTINGS, fetchType_settings);
  yield takeEvery(ADD_NEW_TYPE_SETTING, onAddNewType_settings);
  yield takeEvery(UPDATE_TYPE_SETTING, onUpdateType_settings);
  yield takeEvery(DELETE_TYPE_SETTING, onDeleteType_settings);
  // yield takeEvery(GET_ADMIN_PROFILE, fetchType_settingsProfile);
}

export default ceremonysSaga;
